<template>
  <span :class="this.Css">{{ Time }}</span>
</template>

<script>
  let moment = require("moment");
  export default {
    props: ["time", "format", "css", "humanize"],
    data() {
      return {
        Time: "",
        Fromat: "YYYY-MM-DD HH:mm A",
        Css: "",
        Offset: 0,
        Humanize: false
      };
    },
    created() {
      this.Time = this.time;
      if (
              this.format &&
              this.format != undefined &&
              this.format != null &&
              this.format != ""
      ) {
        this.Fromat = this.format;
      }
      if (
              this.css &&
              this.css != undefined &&
              this.css != null &&
              this.css != ""
      ) {
        this.Css = this.css;
      }
      if (
              this.css &&
              this.css != undefined &&
              this.css != null &&
              this.css != ""
      ) {
        if (
                this.humanize == 1 ||
                this.humanize == true ||
                this.humanize == "true" ||
                this.humanize == "t" ||
                this.humanize == "yes" ||
                this.humanize == "y"
        )
          this.Humanize = true;
      }

      this.toLocal();
    },
    methods: {
      toLocal: function() {
        let offset = moment().utcOffset();
        this.Offset = offset;
        let time = "";

        if (this.Humanize == true) {
          let t = moment(this.time, "YYYY-MM-DD HH:mm A").add(
                  this.Offset,
                  "minutes"
          );
          let now = moment();
          this.Time = moment.duration(t.diff(now)).humanize();
        } else {
          this.Time = moment(this.time, "YYYY-MM-DD HH:mm A")
                  .add(this.Offset, "minutes")
                  .format(this.Fromat);
        }
      }
    },
    watch: {
      Fromat: {
        handler() {
          this.toLocal();
        }
      },
      Offset: {
        handler() {
          this.toLocal();
        }
      },
      time: {
        handler() {
          this.toLocal();
        }
      }
    }
  };
</script>
